/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import { withTranslation } from 'react-i18next';

import {
  Table,
} from 'reactstrap';

import { get } from '../../helpers/api_helper';

function Inspector(props) {
  const { t, item, device } = props;

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [isGallery, setIsGallery] = useState(false);
  const [imageIndex, setImageIndex] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      const response = await get(`/api/items/get/${item.id}`);
      setData(response);
      setLoading(false);
    };

    fetchData();
  }, [item]);

  const jsx = (
    <div>
      <div className="popup-gallery hstack gap-2">
        {data && data.images.length > 0 && data.images.map((x, i) => (
          <div key={x.id} className="img-fluid">
            <img
              src={x.url}
              alt={x.alt}
              style={{
                cursor: 'pointer', width: '100%', maxWidth: '500px', maxHeight: '400px',
              }}
              onClick={() => { setIsGallery(true); setImageIndex(i); }}
            />
          </div>
        ))}
      </div>

      <div className="table-responsive">
        <Table size="sm" bordered className="mt-4">
          <tbody>
            <tr>
              <th>{t('Item ID')}</th>
              <td>
                {loading === true ? t('Loading...') : data.id}
                {' '}
                {loading === false && data !== null && (
                <a
                  href={`/item/${data.id}`}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={t('Open item in new tab')}
                >
                  <span className="mdi mdi-open-in-new" aria-hidden="true" />
                </a>
                )}
              </td>
            </tr>
            <tr>
              <th>{t('Part Number')}</th>
              <td>{loading === true ? t('Loading...') : data.part_number}</td>
            </tr>
            <tr>
              <th>{t('Description')}</th>
              <td>{loading === true ? t('Loading...') : data.customs_description}</td>
            </tr>
            <tr>
              <th>{t('Condition')}</th>
              <td>{loading === true ? t('Loading...') : data.condition}</td>
            </tr>
          </tbody>
        </Table>
      </div>

      <div className="table-responsive">
        <Table bordered>
          <tbody>
            <tr>
              <th>{t('Visible Numbers')}</th>
              <td>
                {loading === true ? t('Loading...') : data.boardNumbers.map(
                  (x) => (x.label === 'Visible Number' ? x.value : ''),
                ).filter((str) => str !== '').join(', ')}
              </td>
            </tr>
            <tr>
              <th>{t('Manufacturer Part Numbers')}</th>
              <td>
                {loading === true ? t('Loading...') : data.boardNumbers.map(
                  (x) => (x.label === 'Manufacturer Part Number' ? x.value : ''),
                ).filter((str) => str !== '').join(', ')}
              </td>
            </tr>
          </tbody>
        </Table>
      </div>

      <div className="table-responsive" style={{ maxHeight: '500px', overflowY: 'auto' }}>
        <Table size="sm" bordered striped className="mt-3">
          <tbody>
            <tr>
              <th>{t('Device')}</th>
              <td>{t('Version')}</td>
            </tr>
            {data && data.devices && data.devices.map((dev) => (
              <tr key={dev.id} className={device !== null && dev.id === device.id ? 'table-success' : ''}>
                <th>{`${dev.brand} ${dev.model}`}</th>
                <td>{dev.version && dev.version.split(',').join(', ')}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      {isGallery ? (
        <Lightbox
          mainSrc={data.images[imageIndex].url}
          enableZoom={false}
          onCloseRequest={() => setIsGallery(false)}
          imageCaption={data.images[imageIndex].label}
        />
      ) : null}
    </div>
  );

  return jsx;
}

Inspector.defaultProps = {
  device: null,
};

Inspector.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  item: PropTypes.object.isRequired,
  device: PropTypes.object,
};

export default connect(() => ({

}), {})(withTranslation()(Inspector));
